import { XMarkIcon } from "@heroicons/react/24/outline";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute text-gray-600 top-4 right-4 hover:text-black"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>

        {/* Header with emoji */}
        <div className="mb-4 text-center">
          <h2 className="mb-2 text-2xl font-bold text-black">
            Are you sure about deleting it?{" "}
          </h2>
          <p className="text-gray-700">
            This action cannot be undone once deleted. Please ensure you want to
            permanently delete this item.{" "}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col gap-3 mt-6">
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 text-black transition-colors bg-custom-yellow hover:bg-black hover:text-white"
          >
            Submit
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-black transition-colors border border-gray-300 hover:bg-gray-100"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
